import { useToggle } from "react-use"

import { ConnectionStatusModal } from "../ConnectionStatusModal"

import styles from "./style.module.scss"

import { Icon } from "components"

interface Props {
    text: string
    toggleHelpModal: () => void
    close: () => void
}

export function ConnectionStatusAlert({ text, toggleHelpModal, close }: Props) {
    const [isOpenedConnectionStatusModal, toggleIsOpenedConnectionStatusModal] = useToggle(false)

    return (
        <>
            <div className={styles.connectionStatus} onClick={toggleIsOpenedConnectionStatusModal}>
                <Icon className={styles.connectionStatusIcon} type="error_outline" size={24} />
                <span>{text}</span>
                <div className={styles.closeIconWrapper} onClick={() => close()}>
                    <Icon type="off-close" size={16} />
                </div>
            </div>
            <ConnectionStatusModal
                hideModal={toggleIsOpenedConnectionStatusModal}
                isModalShown={isOpenedConnectionStatusModal}
                onLinkClick={() => {
                    toggleIsOpenedConnectionStatusModal()
                    toggleHelpModal()
                }}
            />
        </>
    )
}
